
// Estilos
import styles from './loader.module.css';

function Loader({ message = 'Carregando' }) {
    return (
        <div className={styles.loaderOverlay}>
            <div>

            </div>
            <div className={styles.loaderWrapper}>
                <svg
                    className={styles.loader}
                    viewBox="0 0 100 100"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        className={styles.leftBar}
                        d="M47 24.2 L25 60"
                        strokeLinecap="square"
                    />
                    
                    <path
                        className={styles.rightBar}
                        d="M53 24.2 L75 60"
                        strokeLinecap="square"
                    />

                    <polygon
                        points="44 18, 56 18, 50 29"
                        className={styles.triangle}
                    />
                </svg>
                
                <p className={styles.message}>{message}<span className={styles.dots}></span></p>
            </div>
        </div>
    );
}

export default Loader;